import { render, staticRenderFns } from "./PauseModal.vue?vue&type=template&id=6bf438c3&scoped=true"
import script from "./PauseModal.vue?vue&type=script&lang=js"
export * from "./PauseModal.vue?vue&type=script&lang=js"
import style0 from "./PauseModal.vue?vue&type=style&index=0&id=6bf438c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf438c3",
  null
  
)

export default component.exports